import React from "react";
import landingmobilebg from '../assets/images/landing-mobile-bg.png';
import bottle_of_milknew from '../assets/images/bottle_of_milknew.png';

function Banner() { 
  return (

    <div className="layer-1-holder">
      <img src={landingmobilebg} className="hidedesktop landingmobilebg" alt="landingmobilebg"/>
      <img src={bottle_of_milknew} className="depositphotos_386131174_xl-2015" alt="fruit"/>
    </div>

    );
}

export default Banner;
